import emailjs from '@emailjs/browser';

const sendEmail = (formData) => {
  const templateParams = {
    name: formData.name,
    email: formData.email,
    message: formData.message,
  };

  emailjs
    .send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,  // Using environment variable for service ID
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // Using environment variable for template ID
      templateParams,
      process.env.REACT_APP_EMAILJS_USER_ID      // Using environment variable for user ID
    )
    .then(
      (response) => {
        console.log("Success:", response);
        alert(`Thanks ${formData.name}, I will shortly connect with you!`);
      },
      (error) => {
        console.error("Error:", error);
        alert("Error submitting the form. Please try again.");
      }
    );
};

export default sendEmail;
